export default "__VITE_ASSET__f37b4ce1__"